export const getStartedVideoIdV3 = "6380060508112";

export const surveyDataV3 = [
  {
    passionName: "golf",
    iconName: "golf",
    passionId: "golf",
    videoId: "6369690751112",
  },
  {
    passionName: "music",
    iconName: "music",
    passionId: "music",
    videoId: "6384609187112",
  },
  {
    passionName: "arts & culture",
    iconName: "culture",
    passionId: "culture",
    videoId: "6371544156112",
  },
  {
    passionName: "beaches",
    iconName: "beach",
    passionId: "beach",
    videoId: "6384610638112",
  },
  {
    passionName: "spas",
    iconName: "spa",
    passionId: "spa",
    videoId: "6371234521112",
  },
  {
    passionName: "food",
    iconName: "culinary",
    passionId: "culinary",
    videoId: "6371232696112",
  },
  {
    passionName: "skiing & snowboarding",
    iconName: "ski",
    passionId: "ski",
    videoId: "6384619987112",
  },
  {
    passionName: "paddle sports",
    iconName: "paddle",
    passionId: "paddle",
    videoId: "6384678198112",
  },
  {
    passionName: "biking",
    iconName: "bike",
    passionId: "bike",
    videoId: "6384611244112",
  },
  {
    passionName: "fishing",
    iconName: "fish",
    passionId: "fish",
    videoId: "6384703559112",
  },
  {
    passionName: "scuba & snorkel",
    iconName: "dive",
    passionId: "dive",
    videoId: "6384577702112",
  },
  {
    passionName: "safari",
    iconName: "safari",
    passionId: "safari",
    videoId: "6384720797112",
  },
  {
    passionName: "surfing",
    iconName: "surf",
    passionId: "surf",
    videoId: "6384664413112",
  },
  {
    passionName: "hiking",
    iconName: "hike",
    passionId: "hike",
    videoId: "6384687417112",
  },
];
